import {Component, OnDestroy, OnInit} from '@angular/core';
import moment from 'moment';
import {interval, Subscription} from 'rxjs';
import {environment} from '@env/environment';
import {ModuleService} from '@app/shared/services';
import {RouterLink} from '@angular/router';
import {CommonModule} from '@angular/common';


@Component({
  selector: 'app-dashboards',
  templateUrl: './dashboards.component.html',
  imports: [
    RouterLink,
    CommonModule,
  ],
  styleUrls: ['./dashboards.component.scss']
})
export class DashboardsComponent implements OnInit, OnDestroy {
  public user_rights: any = {};
  public menulist: any [] = [];
  public setting = environment;
  public userCredentials = JSON.parse(localStorage.getItem('user') || "{}");
  public now = new Date();
  public date: any;

  public user_id = this.userCredentials.user_id;
  public subscription: Subscription = new Subscription();
  source = interval(5000);
  name: any;

  constructor(public moduleService: ModuleService) {

  }

  ngOnInit() {
    this.loadModules();
    this.formatDateTime(this.now);
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public formatDateTime(data: any) {
    if (this.now) {
      this.date = moment(this.now, 'yyyy-MM-D HH:mm.ss a').format('D-MM-Y HH:MM:ss');
    }
    if (data) {
      data = moment(data, 'yyyy-MM-D HH:mm.ss a').format('D-MM-Y HH:MM:ss');
      return data;
    }
  }

  loadModules() {
    const sentData = {
      user_group: this.userCredentials.user_login
    };
    this.moduleService.getModules(sentData).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.menulist = result["data"];
        localStorage.setItem('modules', JSON.stringify(result["data"]));
      }
    });
  }

}
